module.exports = {"341871001":"天湖街道","341871002":"飞彩街道","341871003":"金坝街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341871.json
// module id = 1159
// module chunks = 0